import CircularProgress from '@material-ui/core/CircularProgress';
import { matchPath, withRouter } from 'react-router';
import { Subscribe } from 'unstated';

import UserContainer from '~/containers/User';

import styles from './Gatekeeper.style';

class Gatekeeper extends React.Component {
  componentDidUpdate() {
    const {
      history,
      needsToOnboard,
      noAccess,
      currentAccountLoaded,
    } = this.props;

    if (
      needsToOnboard() &&
      (history.location.pathname !== '/welcome' &&
        !matchPath(history.location.pathname, {
          path: '/forms',
        }))
    ) {
      history.push('/welcome');
    }

    if (
      currentAccountLoaded &&
      noAccess &&
      history.location.pathname !== '/no-access'
    ) {
      history.push('/no-access');
    }

    if (
      currentAccountLoaded &&
      !noAccess &&
      history.location.pathname === '/no-access'
    ) {
      history.push('/');
    }
  }

  render() {
    const { classes, currentUserLoaded, currentAccountLoaded } = this.props;

    if (currentUserLoaded && currentAccountLoaded) {
      return true;
    }

    return (
      <div className={classes.root}>
        <CircularProgress />
      </div>
    );
  }
}

Gatekeeper.propTypes = {
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  noAccess: PropTypes.bool.isRequired,
  needsToOnboard: PropTypes.func.isRequired,
  currentAccountLoaded: PropTypes.bool.isRequired,
  currentUserLoaded: PropTypes.bool.isRequired,
};

const SubscribedGatekeeper = (props) => (
  <Subscribe to={[UserContainer]}>
    {(container) => (
      <Gatekeeper
        currentUserLoaded={container.currentUserLoaded()}
        currentAccountLoaded={container.currentAccountLoaded()}
        noAccess={container.hasNoAccess()}
        needsToOnboard={container.needsToOnboard}
        {...props}
      />
    )}
  </Subscribe>
);

// withRouter is important here because this component lives outside our normal switch statement.
// For example an update wont happen if a user clicks the browser back button
export default withRouter(withStyles(styles)(SubscribedGatekeeper));
